import { HttpErrorResponse } from '@angular/common/http';

import { ServerError } from '../models/response/server-error';

export function responseErrorHandler(err: HttpErrorResponse): string {
    const error: ServerError = err.error && err.error.error;
    return  (error) ? error.message : 'Unknown error';
}
